import {ControlledSwitch} from '@hm/fundamental'
import React, {useMemo} from 'react'
import {useTranslation} from 'react-i18next'

import {FEATURE_NAMESPACE} from '../../consts'
import {ValueDisplayMode, VALUE_DISPLAY_MODES} from '../../types'

interface ValueDisplayToggleProps {
  value: ValueDisplayMode
  onChange: (value: ValueDisplayMode) => void
}

export const ValueDisplayToggle: React.FC<ValueDisplayToggleProps> = ({value, onChange}) => {
  const {t} = useTranslation(FEATURE_NAMESPACE)

  const options = useMemo(
    () =>
      VALUE_DISPLAY_MODES.map((mode) => ({
        label: t(`comparativeAnalysis.chart.valueDisplayMode.${mode}`),
        value: mode
      })),
    [t]
  )

  return (
    <ControlledSwitch
      name="value-display-toggle"
      value={value}
      options={options}
      onChange={(newValue) => onChange(newValue as ValueDisplayMode)}
      data-cy="value-display-toggle"
    />
  )
}
